Confirm = require 'app/scripts/views/lib/confirm'
LabelEditComponent = require 'app/scripts/views/label/label-edit-component'
PopOver = require 'app/scripts/views/lib/pop-over'
Util = require 'app/scripts/lib/util'
View = require 'app/scripts/views/internal/view'
{ track } = require '@trello/analytics'
l = require 'app/scripts/lib/localize'

module.exports = class LabelEditView extends View
  class DeleteButtonComponent extends View
    tagName: 'input'
    className: 'negate'
    attributes: ->
      type: 'submit'
      value: l('delete')
    events: 'click': (e) ->
      Util.stop(e)
      @options.onClick()

  viewTitleKey: 'change label'

  el: ->
    new LabelEditComponent
      model: @model.toJSON()
      submitTextKey: 'save'
      onSubmit: (name, color) =>
        @model.update { color, name }
        @options.onSubmit?()
        PopOver.popView()
      color: @model.get 'color'
      accessoryView: new DeleteButtonComponent
        onClick: @confirmDeleteLabel.bind(@)
    .render()
    .el

  confirmDeleteLabel: ->
    Confirm.pushView 'delete label',
      model: @model
      confirmBtnClass: 'negate'
      popOnClick: true
      # We want to pop TWICE to get out of the parent popup
      popDepth: 2
      fxConfirm: (e) =>
        @model.destroy()
        @options.onSubmit?()
        track('Label', 'Delete')
